module.exports = __webpack_public_path__ + "static/media/dc.ee0f7095.svg";